import { AxiosResponse } from 'axios'
import axios from 'settings/axios'
import qs from 'querystring'
import { apiEndpoints } from 'settings/_apiSettings'

interface Response {
  data: {
    status: SchedulesStatusResponse[]
    total: number
  }
}

interface SchedulesStatusResponse {
  status_code: string
  status_name: string
  partial: number
  percentage: number
}

interface Error {
  response: {
    status: number
  }
}

interface SchedulesData {
  status: SchedulesStatus[]
  schedulesTotal: number
}

export interface SchedulesStatus {
  statusCode: string
  statusName: string
  partial: number
  percentage: number
}

interface ListSchedulesProps {
  initialDate: string
  endDate: string
  statusList?: string[]
  groupBy?: 'status' | 'date' | 'time'
}

export const getListSchedules = async({
  initialDate,
  endDate,
  groupBy,
  statusList
}: ListSchedulesProps): Promise<AxiosResponse> => {
  const endpoint = apiEndpoints.METRICS_SCHEDULES 

  const params = {
    start_date__gte: initialDate,
    start_date__lte: endDate,
    group_by: groupBy,
    status_code: statusList
  }

  return axios.get<Response>(endpoint, { 
    params,
    paramsSerializer: params => {
      return qs.stringify(params)
    },
  })
}

export const listSchedules = ({
  initialDate,
  endDate,
  statusList,
}: ListSchedulesProps): Promise<SchedulesData> => {

  const endpoint = apiEndpoints.METRICS_SCHEDULES 

  const params = {
    start_date__gte: initialDate,
    start_date__lte: endDate
  }
  
  return new Promise<SchedulesData> ((resolve, reject) => {
    axios.get(endpoint, { params })
      .then((response: Response) => {
        const status: SchedulesStatus[] = []
        response.data.status.forEach((item) => {
          if (statusList?.includes(item.status_code)) {
            status.push({
              statusCode: item.status_code,
              statusName: item.status_name,
              partial: item.partial,
            } as SchedulesStatus)
          }

          return null
        })

        const schedulesTotal = status.reduce((prev, curr) => {
          return prev + curr.partial
        }, 0)

        status.forEach(item => {
          item.percentage = Math.round((item.partial / schedulesTotal) * 100)
        })

        resolve({ status, schedulesTotal })
      })
      .catch((error: Error) => {
        reject(error?.response?.status)
      })
  })
}